import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, RUnfilteredIcd, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	AdhocDxConcept,
	ConceptStatusUpdate,
	getConceptStatusValue,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { setInitialAdhocDx } from '../../redux/diagnosisReviewSlice'

export class AdhocDxModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rParse = z.array(RUnfilteredIcd).safeParse(valueForCid(AdhocDxConcept.cid))
		if(!rParse.success) {
			return err(serializeFusionError('AdhoxDxModelReduxPersister rParse', rParse.error))
		}
		dispatch(setInitialAdhocDx(rParse.data))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState): boolean {
		return prevState.diagnosisReview.adhocDx !== nextState.diagnosisReview.adhocDx
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: AdhocDxConcept.cid,
			value: nextState.diagnosisReview.adhocDx,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
